export const sources={};export const img={src:"__VITE_ASSET__8ueCMfJb__",w:36,h:36};export default{sources:sources,img:img};